// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.rowGrid_BsrHT {
  align-items: center;
  display : grid;
  grid-template-columns: 100px 40px 160px 160px;
  column-gap: 16px;
  overflow: visible !important;
  height: 48px;
  padding: var( --size-padSmall ) var( --size-padMedium );
}

.content_IuIaQ {
  width: 100%;
  padding: var( --size-padMedium );
}

.picker_RYDPW .rw-popup .rw-list {
  max-height: 120px;
}

.header_Hx4mb {
  padding-bottom: var( --size-padMedium );
}

.area_rNYgh {
  border-radius: var( --size-padMedium );
  border: 1px solid var( --color-base100 );
}

.area_rNYgh > .rowGrid_BsrHT:nth-child(even) {
  background-color: var( --color-base025 );
}

.area_rNYgh > .rowGrid_BsrHT:nth-child(odd) {
  background-color: var( --color-detailOddRow );
}

.area_rNYgh > .rowGrid_BsrHT.disabled__3ck0 {
  background-color: var( --color-base050 );
}

.borderTop_pOIXp {
  border-top: 1px solid var(--color-base100);
  padding: var(--size-padLarge) 0;
  margin: var(--size-padLarge) 0 0;
}

.tzLabel_RCsRd {
  flex: 0 0 220px;
}

.tzSelector_N6x1m {
  flex-grow: 1;
}`, "",{"version":3,"sources":["webpack://./../../packages/recovr-plugins/lib/details/locationHours/LocationHoursDetailRenderer.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,cAAc;EACd,6CAA6C;EAC7C,gBAAgB;EAChB,4BAA4B;EAC5B,YAAY;EACZ,uDAAuD;AACzD;;AAEA;EACE,WAAW;EACX,gCAAgC;AAClC;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,sCAAsC;EACtC,wCAAwC;AAC1C;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,0CAA0C;EAC1C,+BAA+B;EAC/B,gCAAgC;AAClC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,YAAY;AACd","sourcesContent":[".rowGrid {\n  align-items: center;\n  display : grid;\n  grid-template-columns: 100px 40px 160px 160px;\n  column-gap: 16px;\n  overflow: visible !important;\n  height: 48px;\n  padding: var( --size-padSmall ) var( --size-padMedium );\n}\n\n.content {\n  width: 100%;\n  padding: var( --size-padMedium );\n}\n\n.picker :global( .rw-popup .rw-list ) {\n  max-height: 120px;\n}\n\n.header {\n  padding-bottom: var( --size-padMedium );\n}\n\n.area {\n  border-radius: var( --size-padMedium );\n  border: 1px solid var( --color-base100 );\n}\n\n.area > .rowGrid:nth-child(even) {\n  background-color: var( --color-base025 );\n}\n\n.area > .rowGrid:nth-child(odd) {\n  background-color: var( --color-detailOddRow );\n}\n\n.area > .rowGrid.disabled {\n  background-color: var( --color-base050 );\n}\n\n.borderTop {\n  border-top: 1px solid var(--color-base100);\n  padding: var(--size-padLarge) 0;\n  margin: var(--size-padLarge) 0 0;\n}\n\n.tzLabel {\n  flex: 0 0 220px;\n}\n\n.tzSelector {\n  flex-grow: 1;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"rowGrid": `rowGrid_BsrHT`,
	"content": `content_IuIaQ`,
	"picker": `picker_RYDPW`,
	"header": `header_Hx4mb`,
	"area": `area_rNYgh`,
	"disabled": `disabled__3ck0`,
	"borderTop": `borderTop_pOIXp`,
	"tzLabel": `tzLabel_RCsRd`,
	"tzSelector": `tzSelector_N6x1m`
};
export default ___CSS_LOADER_EXPORT___;
